import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import promisePrototypeFinallyShim from "promise.prototype.finally";
import * as mapboxgl from "mapbox-gl";

import { locale } from "./translate";

const initialize = () => {
  momentDurationFormatSetup(moment as any);
  promisePrototypeFinallyShim.shim();
  moment.locale(locale);
  (mapboxgl as typeof mapboxgl).accessToken = process.env
    .MAPBOX_ACCESS_TOKEN as string;
};
export default initialize;
